"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContainerModule = void 0;
const base_1 = require("./base");
class ContainerModule extends base_1.SurveyModule {
    constructor(_a = {}) {
        var { modules = [] } = _a, rest = __rest(_a, ["modules"]);
        super(rest);
        this._type = "container";
        this.modules = modules;
    }
    validate() {
        return true;
    }
    toBuilderConfig() {
        if (this.validate()) {
            const builderConfigModule = {
                id: this.id,
                modules: this.modules.map((mod) => mod.toBuilderConfig()),
                noBorder: this.noBorder,
                style: this.style,
                type: this.type,
            };
            if (this.tag) {
                builderConfigModule.tag = this.tag;
            }
            return builderConfigModule;
        }
        throw new Error((0, base_1.INVALID_MODULE)(this));
    }
    toSurveyConfig() {
        if (this.validate()) {
            const surveyConfigModule = {
                id: this.id,
                modules: this.modules.flatMap((mod) => mod.toSurveyConfig()),
                noBorder: this.noBorder,
                style: this.style,
                type: this.type,
            };
            if (this.tag) {
                surveyConfigModule.tag = this.tag;
            }
            return surveyConfigModule;
        }
        throw new Error((0, base_1.INVALID_MODULE)(this));
    }
    editProps() {
        return undefined;
    }
}
exports.ContainerModule = ContainerModule;
//# sourceMappingURL=Container.js.map